import { useOrganization } from "@/auth/AuthContext";
import Content from "@/components/Content"
import CountryFlag from "@/components/CountryFlag";
import ExchangeRates from "@/components/ExchangeRates";
import SectionPanel from "@/components/SectionPanel";
import { AmountUtil } from "@/data/AmountUtil";
import { exchangeRateService } from "@/service/ExchangeRateService";
import { Flex, SimpleGrid, Stack, Text, GridItem } from "@chakra-ui/react";
import { useEffect, useState } from "react";

const Rates = () => {
    const organization = useOrganization();
    const base = organization?.currency ?? 'CHF';
    const [data, setData] = useState<Map<string, number>>(new Map());
    const counter = ['MAD', 'ZAR', 'EGP', 'NGN', 'TND', 'TZS'];

    useEffect(() => {
        let active = true;
        setData(new Map());
        exchangeRateService.listRates(base).then(res => {
            if (!active) return;
            setData(new Map(Object.entries(res.rates)));
        });
        return () => { active = false; };
    }, [base]);

    return (
        <Content title='Indikative Wechselkurse'>
            <Stack gap='6' maxW='7xl' mx='auto' minW='0'>
                <SectionPanel>
                    <ExchangeRates key={base} base={base} all={['CHF', 'USD', 'BDT', 'KES', 'UGX', 'NPR', 'LAK', 'KHR', 'MZN', 'MWK', 'EUR'].filter(c => c !== base)} />
                </SectionPanel>
                <SectionPanel>
                    <SimpleGrid
                        columns={{ base: 1, sm: 2, md: 3, xl: 6 }}
                        gap={{ base: 3, md: 4 }}
                        width='100%'
                    >
                        {counter.map(c => {
                            const rate = data.get(c) ?? 0;
                            return (
                                <GridItem
                                    key={c}
                                    borderWidth='1px'
                                    borderColor='border'
                                    bg='bg.panel'
                                    rounded='lg'
                                    minW='0'
                                    textAlign='center'
                                    px={{ base: 3, md: 4 }}
                                    py={{ base: 3, md: 4 }}
                                >
                                    <Flex justify='center' align='center' wrap='wrap'>
                                        <CountryFlag code={base.substring(0, 2)} />
                                        <Text
                                            px='.4rem'
                                            fontWeight={'bold'}
                                            fontSize={{ base: 'xl', md: '1.5rem' }}
                                        >
                                            {base}/{c}
                                        </Text>
                                        <CountryFlag code={c.substring(0, 2)} />
                                    </Flex>
                                    <Text
                                        fontWeight={'semibold'}
                                        fontSize={{ base: 'xl', md: '1.5rem' }}
                                        color={rate > 0 ? 'fg' : 'fg.error'}
                                    >
                                        {AmountUtil.format(rate)}
                                    </Text>
                                </GridItem>
                            )
                        })}
                    </SimpleGrid>
                </SectionPanel>
            </Stack>
        </Content>
    )
}

export default Rates;
